
import { Component, Inject, Vue } from 'vue-property-decorator';
import GeneralScaffold from '@/components/GeneralScaffold.vue';
import PagedDataTable from '@/components/PagedDataTable.vue';
import DirectNavigationItemRepository from '@/repositories/directnavigation/DirectNavigationItemRepository';

@Component({
    components: { GeneralScaffold, PagedDataTable },
})
export default class DirectNavigationListScreen extends Vue {
    @Inject()
    private readonly directNavigationItemRepository!: DirectNavigationItemRepository;

    public get headers(): any[] {
        return [
            {
                text: this.$t('general.actions'),
                value: 'action',
                sortable: false,
            },
            {
                text: this.$t('crud.directNavigationItem.defaultName'),
                align: 'left',
                value: 'defaultName',
                sortable: true,
            },
            {
                text: this.$t('crud.directNavigationItem.order'),
                value: 'order',
                sortable: true,
            },
        ];
    }
}
